<template>
    <div class="flex items-center">
        <div class="flex w-full bg-white">
            <div class="relative text-gray-600 focus-within:text-gray-400 w-full">
                <span class="absolute inset-y-0 left-0 flex items-center pl-2">
                <button type="button" class="p-1 focus:outline-none focus:shadow-outline">
                <i class="fas text-gray-900 fa-search" />
                </button>
                </span>
                <input type="text" name="q"
                       class="w-full pl-8 pb-2.5 pt-3 flex border border-solid border-black rounded-md focus:outline-none focus:bg-white focus:text-gray-900"
                       :value="contentValue" @input="$emit('input', $event.target.value)"
                       placeholder="Buscar" autocomplete="off">
            </div>
        </div>
    </div>
</template>

<script>

import eventBus from "../../Layouts/eventBus";

export default {
    components: {},
    props: {
        value: String,
        maxWidth: {
            type: Number,
            default: 300
        }
    },
    watch: {
        value(){
            if(!this.value) this.contentValue = '';
        }
    },
    data() {
        return {
            contentValue: this.value
        }
    },
    created() {
        eventBus.$on("reset", () => {
            this.contentValue = null;
            this.$emit('input', null);
        });
    }
}
</script>
